<template>
    <div class="edit-content novel-content f-hidden">
        <!-- 与图文内容一致 -->
    </div>
</template>

<script>
export default {
    name: 'novel_create'
}
</script>

<style scoped>

</style>
